import { useEffect, useState } from 'react';
import { Lock } from 'lucide-react';
import { api } from '@/lib/api';
import { toast } from 'sonner';

// Interruptor de impacto financiero real (Modalidad 3 / deducciones). Bloqueado en producción sin autorización.
export const RealModeToggle = ({ getUrl, field, label, onDesc, offDesc, save, testid, onChange }) => {
  const [st, setSt] = useState(null);
  const load = () => api.get(getUrl).then(({ data }) => {
    const on = field === 'checkout_enabled' ? data.settings?.checkout_enabled : data.apply_to_payouts;
    const locked = field === 'checkout_enabled' ? data.live_allowed === false : data.locked;
    setSt({ on: !!on, locked: !!locked }); onChange?.(!!on);
  }).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!st) return null;
  const toggle = async () => {
    const next = !st.on;
    if (!window.confirm(next ? `¿Activar «${label}»? Afecta los cobros y desembolsos de los pedidos nuevos.` : `¿Desactivar «${label}»?`)) return;
    try { await save(next); toast.success(next ? 'Activado' : 'Desactivado'); load(); }
    catch (e) { toast.error(e.response?.data?.detail?.message || 'No se pudo cambiar'); }
  };
  return (
    <div className={`mt-3 flex items-start justify-between gap-3 border p-3 text-sm ${st.on ? 'border-emerald-300 bg-emerald-50 text-emerald-900' : 'border-amber-300 bg-amber-50 text-amber-900'}`} data-testid={testid}>
      <span className="flex items-start gap-2">{st.locked && <Lock className="mt-0.5 h-4 w-4 shrink-0" />}{st.on ? onDesc : offDesc}</span>
      <button disabled={st.locked} onClick={toggle} data-testid={`${testid}-switch`}
        className="shrink-0 border border-current px-3 py-1 text-xs font-bold uppercase tracking-wider disabled:opacity-40">
        {st.locked ? 'Bloqueado' : st.on ? 'Desactivar' : 'Activar'}
      </button>
    </div>
  );
};
